import axiosInstance from "./axiosInstance";

const admissionService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/admission/create', payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAllAdmissions: async () => {
        try {
            const response = await axiosInstance.get('/admission/all');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/admission/total');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchAdmissionById: async (id) => {
        try {
            const response = await axiosInstance.get(`/admission/get/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    update: async (id, payload) => {
        try {
            const response = await axiosInstance.put(`/admission/edit/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    delete: async (id) => {
        try {
            const response = await axiosInstance.delete(`/admission/delete/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default admissionService;